<template>
    <div class="col-12 nopads pb-4">
        <div v-if="!loading && (!results || results.length < 1)" class="col-12 text-center">
            {{ $t('campaign.no_subscriptions') }}
        </div>

        <div v-else>
            <!-- Desktop layout -->
            <table class="table table-striped desktop-view">
                <thead>
                    <tr>
                        <th>{{ $t('campaign.campaign') }}</th>
                        <th>Määrä</th>
                        <th>Maksupäivä</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="sub in results" :key="sub.id">
                        <td>{{ sub.campaignName }}</td>
                        <td>{{ sub.amount / 100 }} €</td>
                        <td>{{ sub.paymentDate | formatDateFromISO }}</td>
                    </tr>
                </tbody>
            </table>

            <!-- Mobile layout, hidden on desktop -->
            <div class="mobile-view">
                <div v-for="sub in results" :key="sub.id" class="mobile-item">
                    <h5>{{ sub.campaignName }}</h5>
                    <p><strong>Määrä:</strong> {{ sub.amount / 100 }} €</p>
                    <p><strong>Maksupäivä:</strong> {{ sub.paymentDate | formatDateFromISO }}</p>
                    <button 
                        v-if="sub.isActive" 
                        @click="openConfirmationDialog(sub)"
                        class="btn btn-warning btn-sm"
                    >
                        Peruuta tilaus
                    </button>
                </div>
            </div>
        </div>

        <div v-if="loading" id="loader" class="spinner" />
    </div>
</template>



<script>
    import {views} from "../../mixins/ViewMixin"
    import {timeMixin} from "../../mixins/TimeMixin"
    import Axios from 'axios';
    export default {
        name: "my-subscriptions",
        mixins: [views, timeMixin],
        components: {},
        selectedSubscription: null,
        filters: {
            formatDateFromISO(isoDate) {
                const date = new Date(isoDate);
                return date.toLocaleDateString('fi-FI');
            }
        },
        data() {
            return {
                views,
                activeTab: 1,
                selectedSub: null,
                loading: false,
                results: [],
                isDialogVisible: false,
            }
        },

        mounted() {
        this.fetchSubscriptions();
        },
    
        methods: {
            fetchSubscriptions() {
                this.loading = true;
                this.results = [];
                Axios.get(`${process.env.VUE_APP_FAIR_API}verifonepayment/onetimedonations`)
                    .then(response => {
                        this.results = response.data || [];
                    })
                    .catch(error => console.error(error))
                    .finally(() => this.loading = false);
            },
    },
        }
</script>

<style scoped>
</style>
